<template>
  <div class="search">
    <el-input
      :placeholder="placeholder"
      v-model="SearchQuery"
      clearable
      @clear="getSearchResult"
      @keyup.enter.native="getSearchResult"
    >
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="getSearchResult"
      ></el-button>
    </el-input>
  </div>
</template>

<script>
export default {
  data() {
    return {
      SearchQuery: "",
    };
  },
  props: {
    placeholder: {
      type: String,
      default: "",
    },
  },
  methods: {
    getSearchResult() {
      this.$emit("search",this.SearchQuery);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./search.scss";
</style>
